import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=16e2e998&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2e998",
  null
  
)

export default component.exports